import { render, staticRenderFns } from "./UnionGrid.vue?vue&type=template&id=052fb3fb&"
import script from "./UnionGrid.vue?vue&type=script&lang=js&"
export * from "./UnionGrid.vue?vue&type=script&lang=js&"
import style0 from "./UnionGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports